import api from '../token';

export const ListInventario = async () => {
  try {
    const response = await api.post('/getInventario');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

